import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import sha1 from 'crypto';
import alert from 'alert';

import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import perfil from '../../assests/perfil.jpg';
import MenuPerfil from '../Includes/MenuPerfil';
import imgAvatar from '../../assests/avatar.png';

import './styles.css';
import { useTranslation } from 'react-i18next';

export default function Perfil() {
  let tmpToken = "";
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [TAGS, setTAGS] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('TAGS'));
      return Array.isArray(cached) ? cached : [];
    } catch (err) {
      return [];
    }
  });
  const [tagsOpen, setTagsOpen] = useState(false);
  const [tagQuery, setTagQuery] = useState('');
  const [selecionadas, setSelecionadas] = useState(() => {
    try {
      const raw = sessionStorage.getItem('tags');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  });
  const tagsBoxRef = useRef(null);
  const msgTimerRef = useRef(null);
  let user = Array;
  const history = useHistory();
  const { t } = useTranslation();

  function tagLabel(name) {
    const bruto = String(name || '').trim();
    if (!bruto) return '';
    const comHash = bruto.charAt(0) === '#' ? bruto : `#${bruto}`;
    return comHash.toUpperCase();
  }

  function lerEscolhidas() {
    try {
      const parsed = JSON.parse(sessionStorage.getItem('tags'));
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function mostrarMensagens(texto, tipo, aoTerminar) {
    ['mensagens1', 'mensagens2'].forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.style.display = 'block';
      el.innerHTML = texto;
      el.classList.remove('erro', 'certo');
      el.classList.add(tipo);
    });
    if (msgTimerRef.current) clearTimeout(msgTimerRef.current);
    msgTimerRef.current = setTimeout(() => {
      ['mensagens1', 'mensagens2'].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.innerHTML = '';
        el.style.display = 'none';
      });
      msgTimerRef.current = null;
      if (aoTerminar) aoTerminar();
    }, 5000);
  }

  useEffect(() => {
    function fecharTags(e) {
      if (tagsBoxRef.current && !tagsBoxRef.current.contains(e.target)) {
        setTagsOpen(false);
      }
    }
    document.addEventListener('mousedown', fecharTags);
    return () => {
      document.removeEventListener('mousedown', fecharTags);
      if (msgTimerRef.current) clearTimeout(msgTimerRef.current);
    };
  }, []);

  // useEffect(() => {
  //   var axios = require('axios');
  //   var FormData = require('form-data');
  //   var data = new FormData();

  //   var config = {
  //     method: 'get',
  //     url: BASE_URL + '/v2/tags',
  //     headers: {
  //       'USER_TOKEN': USER_TOKEN,
  //       'USER_EMAIL': USER_EMAIL,

  //     },
  //     data: data
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       setTAGS(response.data);
  //     })
  //     .catch(function (error) {
  //     });
  // }, [BASE_URL, USER_EMAIL, USER_TOKEN]);

  function handleEditInteresses(e) {
    e.preventDefault();
    var vTags = [];
    var tags = [];
    const vetTagsSession = lerEscolhidas();
    vetTagsSession.forEach(el => {
      tags = [...tags, el.id]
    });
    vTags = { 'tags': tags };
    var axios = require('axios');
    var data = tags;
    var config = {
      method: 'put',
      url: BASE_URL + '/v2/users/me/interests/update_interests',
      headers: {
        'Content-Type': 'application/json',
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      },
      data: vTags
    };

    axios(config)
      .then(function (response) {
        mostrarMensagens(
          t('pages.profileInterests.messages.interestsUpdated'),
          'certo',
          () => history.push('/perfil')
        );
      })
      .catch(function (error) {
      });
  }
  function filtrar(arr, id) {
    var res = []
    for (var i = 0, j = arr.length; i !== j; i++) {
      if (arr[i].id !== id) res.push(arr[i]);
    }
    return res;
  }
  function selecionaTag(tagsId) {
    var cont = 0;
    let vetTags = lerEscolhidas();
    const result = vetTags.find(tag => tag.id === tagsId);
    if (!result) {
      TAGS.forEach(tags => {
        if (tagsId === tags.id && vetTags.length < 7) {
          vetTags = [...vetTags, tags]
        } else {
          cont++;
          if (TAGS.length === cont) {
            mostrarMensagens(t('pages.profileInterests.messages.maxOfTags'), 'erro');
          }
        }
      });

      sessionStorage.setItem('tags', JSON.stringify(vetTags));
      setSelecionadas(vetTags);
    } else {
      if (vetTags.length > 7) {
        mostrarMensagens(t('pages.profileInterests.messages.maxOfTags'), 'erro');
      }
      const vetNovo = filtrar(vetTags, result.id);
      sessionStorage.setItem('tags', JSON.stringify(vetNovo));
      setSelecionadas(vetNovo);
    }
  }


  function verificaTag(tagsId) {
    const result = selecionadas.find(tag => tag.id === tagsId);
    if (!result) {
      return 'tagOFF'
    } else {
      return 'tagON'
    }
  }

  return (
    <FeedLayout active="profile">
    <div className="edit-interesses-container">
      <div className="feed-top">{t('pages.profileInterests.title')}</div>
      <ProfileChips active="profile" />
      <section className="body">
        <form onSubmit={handleEditInteresses}>
          <div id="mensagens1" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
          <div className="conteudo">
            <div className="perfil">
              <div className="clTags" ref={tagsBoxRef}>
                <label>{t('pages.profileInterests.labels.tags')}</label>
                <button
                  type="button"
                  className="tags-select"
                  onClick={() => {
                    try {
                      const cached = JSON.parse(sessionStorage.getItem('TAGS'));
                      if (Array.isArray(cached)) setTAGS(cached);
                    } catch (err) {}
                    setTagsOpen(!tagsOpen);
                  }}
                >
                  <span>
                    {selecionadas.length
                      ? `${selecionadas.length} selecionada${selecionadas.length > 1 ? 's' : ''}`
                      : t('pages.profileInterests.select.tags')}
                  </span>
                  <FiChevronDown />
                </button>
                {tagsOpen && (
                  <div className="tags-panel">
                    <div className="tags-search">
                      <FiSearch />
                      <input
                        type="text"
                        value={tagQuery}
                        onChange={(e) => setTagQuery(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') e.preventDefault();
                        }}
                        placeholder={t('pages.profileInterests.placeholders.searchTag')}
                        autoFocus
                      />
                    </div>
                    <ul className="tags-list">
                      {(TAGS || [])
                        .filter((tag) => {
                          const q = tagQuery.trim().toLowerCase();
                          if (!q) return true;
                          const bruto = String(tag.name || '').toLowerCase();
                          const amigavel = tagLabel(tag.name).toLowerCase();
                          return bruto.indexOf(q) !== -1 || amigavel.indexOf(q) !== -1;
                        })
                        .map((tag) => (
                          <li
                            key={tag.id}
                            className={verificaTag(tag.id) === 'tagON' ? 'is-on' : ''}
                            onClick={() => selecionaTag(tag.id)}
                          >
                            {tagLabel(tag.name)}
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
                {selecionadas.length > 0 && (
                  <div className="tags-chosen">
                    {selecionadas.map((tag) => (
                      <button
                        type="button"
                        key={tag.id}
                        className="tag-chip"
                        onClick={() => selecionaTag(tag.id)}
                      >
                        {tagLabel(tag.name)} ×
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="interesses-acoes">
                <button type="submit" className="btnEnviar">{t('pages.profileInterests.buttons.update')}</button>
              </div>
            </div>
            <MenuPerfil />

          </div>
          <div id="mensagens2" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
        </form>
      </section>
    </div>
    </FeedLayout>
  )
}